import Vue from "vue";

// Create a new Vue instance and export it
const event = new Vue();

export default event;
